import { Box, Grid, Typography, useTheme } from '@mui/material';
import Card from 'components/Card';
import NumberFormats from 'components/NumberFormats';
import { DefaultUrlWeb } from 'config/Configuration';
import React from 'react';
import WrapperAction from './Action';
import Status from './Status';
import ProfitLost from './ProfitLost';
import FluctuationChartAction from './Fluctuation/FluctuationChartAction';

function FloatingBox({
  floatingFundItem,
  handleShowDetails,
  handleShowAction,
  handleOpenChart,
}) {
  const theme = useTheme();

  return (
    <Card
      shadow={theme.shadows[1]}
      maxHeight="initial"
      padding="16px 16px 16px 16px !important"
      sx={{ paddingBottom: '16px' }}
    >
      <Grid
        container
        display="flex"
        flexDirection="row-reverse"
        alignItems="start"
      >
        <Grid
          item
          xs={2}
          display="flex"
          justifyContent="flex-end"
          onClick={handleShowDetails}
        >
          <img
            width="30px"
            src={`${DefaultUrlWeb}${floatingFundItem.coinImageUrl}`}
            alt={floatingFundItem.name}
          />
        </Grid>

        <Grid item xs={10}>
          <Grid container dir="ltr" spacing={1}>
            <Grid item xs={6} onClick={handleShowDetails}>
              <Typography variant="subtitle2" mb={0.5} color="text.secondary">
                Amount:
              </Typography>

              <Box display="flex">
                <Typography variant="h6" fontWeight={400} color="text.main">
                  <NumberFormats
                    displayType={'text'}
                    value={floatingFundItem?.amount}
                    thousandSeparator={true}
                  />
                </Typography>

                <Typography variant="subtitle1" color="text.secondary">
                  {floatingFundItem?.nameCoin}
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={6} onClick={handleShowDetails}>
              <Typography variant="subtitle2" mb={0.5} color="text.secondary">
                Profit/Loss:
              </Typography>

              <ProfitLost data={floatingFundItem} />
            </Grid>

            <Grid item xs={6} onClick={handleShowDetails}>
              <Typography variant="subtitle2" mb={0.5} color="text.secondary">
                Total:
              </Typography>
              <Box display="flex">
                <Typography variant="h6" fontWeight={400} color="text.main">
                  <NumberFormats
                    displayType={'text'}
                    value={floatingFundItem?.total}
                    thousandSeparator={true}
                  />
                </Typography>
                <Typography variant="subtitle1" color="text.secondary">
                  {floatingFundItem?.nameCoin}
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={6} onClick={handleShowDetails}>
              <Typography variant="subtitle2" mb={0.5} color="text.secondary">
                Status:
              </Typography>

              <Box display="flex" alignItems="center">
                <Status data={floatingFundItem} />
              </Box>
            </Grid>

            <Grid item xs={6}>
              <Box display={'flex'} alignItems={'center'} justifyContent={"flex-start"} gap={1}>
              <FluctuationChartAction
                data={floatingFundItem}
                handleOpenChart={handleOpenChart}
              />
              </Box>
            </Grid>

            <Grid item xs={6}>
              <Box display={'flex'} alignItems={'center'} justifyContent={"flex-start"} gap={1} height={"100%"}>
                <WrapperAction
                  data={floatingFundItem}
                  handleShowDetails={handleShowDetails}
                  handleShowAction={handleShowAction}
                />
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Card>
  );
}

export default FloatingBox;
